import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  Tooltip,
} from "@mui/material";
import { forwardRef } from "react";

interface IconButtonProps extends MuiIconButtonProps {
  tooltip?: string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { children, tooltip, ...rest } = props;

    const button = (
      <MuiIconButton ref={ref} size="small" {...rest}>
        {children}
      </MuiIconButton>
    );

    if (tooltip) {
      return <Tooltip title={tooltip}>{button}</Tooltip>;
    }

    return button;
  }
);

IconButton.displayName = "IconButton";

export default IconButton;
